// AUTO-GENERATED at build time by scripts/inject-build-info.js.
// Do not edit by hand — your changes will be overwritten on the next build.
export const BUILD_INFO = {
    "commit": "dev",
    "branch": "local",
    "builtAt": "2026-10-31T00:43:18.746Z"
};
